import { useQuery } from '@tanstack/react-query';
import { getStates, getCities } from '@/api/location';

export function useStates(search: string) {
  return useQuery({
    queryKey: ['location-states', search],
    queryFn: () => getStates(search),
    placeholderData: (previousData) => previousData,
  });
}

export function useCities(stateCode: string, search: string) {
  return useQuery({
    queryKey: ['location-cities', stateCode, search],
    queryFn: () => getCities(stateCode, search),
    enabled: Boolean(stateCode),
    placeholderData: (previousData) => previousData,
  });
}
